import Modal from 'react-modal';
import { Flex } from '@components/Flex';
import { styled } from '@styledComponents';
import { Button } from '@components/Button';
import { Text } from '@components/typography';
import { Columns } from '@components/Columns';
import { JoykitIcon } from '@components/JoykitIcon';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const StyledModal = styled(Modal)`
  background-color: transparent;
  border: none;
  margin: auto;
  width: 63%;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  ${themeMediaQuery('sm')} {
    width: 100%;
  }
  ${themeMediaQuery('md')} {
    width: 96%;
  }
  @media (min-width: 1400px) {
    width: 82%;
  }
  ${themeMediaQuery('lg')} {
    width: 80%;
  }
  ${themeMediaQuery('xl')} {
    width: 67%;
  }
  @media (min-width: 1920px) {
    width: 63%;
  }
`;

export const StyledColumns = styled(Columns)`
  background: ${themeColor('white')};
  height: 560px;
  width: 830px;
  border-radius: ${themeSpace(4)};
  position: relative;
  margin-left: 0;
  margin-right: 0;
  ${themeMediaQuery('below_sm')} {
    margin: auto;
    padding: ${themeSpace(5)};
    height: auto;
    max-height: 100%;
    width: 100%;
  }
  ${themeMediaQuery('sm')} {
    max-width: 60rem;
  }
  ${themeMediaQuery('md')} {
    max-width: 70rem;
  }
  ${themeMediaQuery('xl')} {
    max-width: 75rem;
  }
`;

export const StyledCloseButton = styled(Button)`
  position: absolute;
  top: 10px;
  right: 0;
  padding: ${themeSpace(3)};
  background: none;
  border: none;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  :focus {
    outline: none;
  }
  :focus {
    background-color: transparent;
  }
  ${themeMediaQuery('below_sm')} {
    top: -11px;
  }
`;

export const StyledInnerContainer = styled(Flex)`
  width: 100%;
  height: 100%;
  padding: ${themeSpace(4)};
`;

export const StyledCloseIcon = styled(JoykitIcon)`
  width: ${themeSpace(5)};
  height: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    width: ${themeSpace(4)};
    height: ${themeSpace(4)};
  }
`;
export const StyledUserStory = styled(Text)`
  overflow-y: auto;
  max-width: 50%;
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(6)};
    max-height: calc(80vh - 276px);
    max-width: 100%;
  }
  ${themeMediaQuery('tablet')} {
    width: 100%;
    margin-top: ${themeSpace(6)};
    max-height: calc(80vh - 587px);
  }
  ::-webkit-scrollbar {
    background-color: ${themeColor('white')};
    width: 13px;
  }

  ::-webkit-scrollbar-track {
    background-color: ${themeColor('white')};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${themeColor('mono3')};
    border-radius: 16px;
    border: ${themeSpace(1)} solid ${themeColor('white')};
  }

  ::-webkit-scrollbar-button {
    display: none;
  }
`;

export const ImgContainer = styled.div<{ src: string }>`
  width: 100%;
  background-image: ${(props) => `url(${props.src})`};
  background-size: cover;
  background-position: center center;
  border-radius: ${themeSpace(3)};
  ${themeMediaQuery('below_sm')} {
    height: 174px;
  }
  ${themeMediaQuery('tablet')} {
    height: 280px;
  }
`;

export const StyledFlex = styled(Flex)`
  max-height: 75%;
  ${themeMediaQuery('below_sm')} {
    flex-direction: column-reverse;
  }
`;
